<template lang="pug">
  .gallery(v-if="contents && contents.length", :class="[spacingTop, spacingBottom]")
    .dynamic-grid(v-if="layout === 'dynamic-grid'")
        DynamicGrid(:contents="contents", :settings="settings")
    .simple-grid(v-else)
        SimpleGrid(:contents="contents", :settings="settings")
</template>

<script>
import { get, cloneDeep } from '@/helpers';

import DynamicGrid from './DynamicGrid';
import SimpleGrid from './SimpleGrid';

export default {
    name: 'PhotoAlbum',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        DynamicGrid,
        SimpleGrid
    },
    computed: {
        settings() {
            return get(this.section, 'settings') || [];
        },
        contents() {
            let contents = this.section.contents || [];
            return cloneDeep(contents).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },
        layout() {
            let layout = 'dynamic-grid';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'layout');
                if (setting && setting.value !== undefined) layout = setting.value;
            }
            return layout;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.gallery
  .wrap
    @apply relative
</style>
